





























































































































































































































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import { State } from 'vuex-class';
import { RootStoreState } from '@/store';
import ApiServiceWrapper from '@/shared/api-request.service';
@Component({
  components: {
    ...UUIFComponent,
  },
})
export default class ProductAssociation extends SwExtendedVue {
  @Prop()
  showAssociationProduct: boolean;
  @Prop()
  associatedTask: any;
  @Prop()
  isClosedNetworkEnabled: boolean;
  @State((state: RootStoreState) => state.MswProductsStoreModule.productDetails)
  productDetails: any;
  hasAssociations: boolean = false;
  associatedProducts: any = [];
  msgGMS2: string = '';
  msgGMS1: string = '';
  availableAssociates: any = [];
  selectedSerialNumber: string = '';
  assocErr: string = '';
  updateProductDetail: boolean = false;
  hideAddAssociation: boolean = false;
  noAsscociatedProdsMsg: string = '';
  isSSE: boolean = false;
  isSubmitted: boolean = false;
  friendlyName: string = '';
  guid: string = '';
  closeDialog() {
    this.$emit('closeDialog', this.updateProductDetail);
  }
  mounted() {
    this.getAssociatedProductsDetail();
    this.hideAddAssociation =
      this.associatedTask.assocTypeName.toLowerCase() === 'sonicwave' ||
      this.associatedTask.assocTypeName.toLowerCase() === 'storagemodule' ||
      this.associatedTask.assocTypeName.toLowerCase() === 'storage module' ||
      this.associatedTask.assocTypeName.toLowerCase() === 'switch' ||
      this.associatedTask.assocTypeName.toLowerCase() === 'firewall connector';
    if (this.associatedTask.assocTypeName.toLowerCase() === 'firewall connector') {
      this.isSSE = true;
    }
  }

  getAssociatedProductsDetail() {
    Promise.all([
      this.$store.dispatch(
        'MswProductsStoreModule/getAssociatedProducts',
        this.associatedTask.assoTypeID,
      ),
      this.$store.dispatch(
        'MswProductsStoreModule/getProductsForAssociation',
        this.associatedTask.assoTypeID,
      ),
    ]).then((res: any) => {
      this.$store.commit('stopLoading');
      if (res[0].operationStatus === 'OK' && res[0].msgCode === 'MSWAPP:SUCCESS') {
        this.hasAssociations = true;
        this.associatedProducts = res[0].content.prodList;
        this.msgGMS2 = res[0].content.msgGMS;
      } else if (res[0].msgCode === 'MSWAPP:NOASSOCPRODUCTS') {
        this.noAsscociatedProdsMsg = res[0].msgDesc;
        this.hasAssociations = false;
      } else {
        this.hasAssociations = false;
      }
      if (res[1].msgCode === 'MSWAPP:SUCCESS') {
        this.availableAssociates = res[1].content.prodList.map((each: any) => {
          return {
            id: each.serNo,
            label: `${each.serNo} - ${each.friendlyName}`,
            value: each.serNo,
          };
        });
        this.msgGMS1 = res[1].content.msgGMS;
        this.selectedSerialNumber = this.availableAssociates[0].value;
      } else {
        this.availableAssociates = [];
        this.assocErr = res[1].msgDesc;
      }
    });
  }
  addAssociation() {
    const request = {
      userName: this.$store.getters.getUserId,
      associationTypeID: this.associatedTask.assoTypeID,
      primarySerialNumber: this.productDetails.serialNumber,
      secondarySerialNumber: this.selectedSerialNumber,
    };
    this.$store
      .dispatch('MswProductsStoreModule/addProductAssocition', request)
      .then((res: any) => {
        this.$store.commit('stopLoading');
        if (res.operationStatus === 'OK' && res.msgCode === 'MSWAPP:SUCCESS') {
          this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: res.msgDesc });
          this.updateProductDetail = true;
          this.closeDialog();
        } else {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: res.msgDesc });
        }
      });
  }
  removeAssociation(serialNumber: string) {
    if (this.$store.getters.getMsgQueue && this.$store.getters.getMsgQueue.length > 0) {
      this.$store.commit('clearEnqueMessage');
    }
    const request = {
      userName: this.$store.getters.getUserId,
      associationTypeID: this.associatedTask.assoTypeID,
      primarySerialNumber: this.productDetails.serialNumber,
      secondarySerialNumber: serialNumber,
    };
    this.$store
      .dispatch('MswProductsStoreModule/removeProductAssocition', request)
      .then((res: any) => {
        this.$store.commit('stopLoading');
        if (res.operationStatus === 'OK' && res.msgCode === 'MSWAPP:SUCCESS') {
          this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: res.msgDesc });
          this.updateProductDetail = true;
          this.getAssociatedProductsDetail();
        } else {
          this.$store.commit('enqueueMessage', {
            infoType: 'failed',
            infoMsg: res.msgDesc || 'Something went wrong.',
          });
        }
      });
  }
  selectSerialNumber(selectedSerialNumber: string) {
    this.selectedSerialNumber = selectedSerialNumber;
  }
  replaceLocation(childSerialNumber: string) {
    const endpoint = 'product/getNSMManagedNodelicensesKeyset';
    const userID = this.$store.getters.getUserId;
    const sessionID = JSON.parse(this.$store.getters.getUserInfo).user.sessionId;
    const serialNumber = this.productDetails.serialNumber;
    const url = `${endpoint}?username=${userID}&sessionID=${sessionID}&serial=${serialNumber}&childSerial=${childSerialNumber}`;
    ApiServiceWrapper.replaceTiltPipe(url);
  }
  addNewAgent() {
    this.isSubmitted = true;
    const payload = {
      primarySerialNumber: this.productDetails.serialNumber,
      friendlyName: this.friendlyName,
      SoftwareGuid: this.guid,
    };
    this.$store
      .dispatch('MswProductsStoreModule/registerSoftware', payload)
      .then((res: any) => {
        this.$store.commit('stopLoading');
        if (res.operationStatus === 'OK' && res.msgCode === 'MSWAPP:REGSERNOSUCCESS') {
          this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: res.msgDesc });
          this.friendlyName = '';
          this.guid = '';
          this.updateProductDetail = true;
          this.getAssociatedProductsDetail();
        } else {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: res.msgDesc });
        }
      });
  }
}
